import { render, staticRenderFns } from "./CalculationQuestions.vue?vue&type=template&id=1ccff80e&scoped=true"
import script from "./CalculationQuestions.vue?vue&type=script&lang=js"
export * from "./CalculationQuestions.vue?vue&type=script&lang=js"
import style0 from "./CalculationQuestions.vue?vue&type=style&index=0&id=1ccff80e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccff80e",
  null
  
)

export default component.exports